export const API_URL = process.env.REACT_APP_HOST_INTELLIKASIR;
export const MIDTRANS_API_URL = process.env.REACT_APP_MIDTRANS_API_URL;
export const MIDTRANS_CLIENT_ID = process.env.REACT_APP_MIDTRANS_CLIENT_ID;